(function () {
  'use strict';

  function initMegaMenu(root) {
    if (!root || root.dataset.jsmegaReady === 'true') return;
    root.dataset.jsmegaReady = 'true';

    var topItems = Array.prototype.slice.call(root.querySelectorAll('[data-jsmega-topitem].has-submenu'));

    function closeAll(except) {
      topItems.forEach(function (item) {
        if (item !== except) {
          item.classList.remove('is-open');
          var link = item.querySelector(':scope > .jsmega__toplink');
          if (link) link.setAttribute('aria-expanded', 'false');
        }
      });
    }

    topItems.forEach(function (topItem) {
      var topLink = topItem.querySelector(':scope > .jsmega__toplink');
      var panel = topItem.querySelector(':scope > [data-jsmega-panel]');
      if (!topLink || !panel) return;

      topLink.addEventListener('click', function (event) {
        if (window.matchMedia('(min-width: 992px)').matches && (event.pointerType === 'touch' || !window.matchMedia('(hover:hover)').matches)) {
          if (!topItem.classList.contains('is-open')) {
            event.preventDefault();
            closeAll(topItem);
            topItem.classList.add('is-open');
            topLink.setAttribute('aria-expanded', 'true');
          }
        }
      });

      topItem.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(min-width: 992px)').matches) return;
        closeAll(topItem);
        topLink.setAttribute('aria-expanded', 'true');
      });

      topItem.addEventListener('mouseleave', function () {
        if (!topItem.classList.contains('is-open')) topLink.setAttribute('aria-expanded', 'false');
      });

      var categories = Array.prototype.slice.call(panel.querySelectorAll('[data-jsmega-category]'));
      var contents = Array.prototype.slice.call(panel.querySelectorAll('[data-jsmega-content]'));

      function activate(index) {
        categories.forEach(function (category) {
          category.classList.toggle('is-active', category.getAttribute('data-panel-index') === index);
        });
        contents.forEach(function (content) {
          content.classList.toggle('is-active', content.getAttribute('data-panel-index') === index);
        });
      }

      categories.forEach(function (category) {
        var index = category.getAttribute('data-panel-index');
        category.addEventListener('mouseenter', function () { activate(index); });
        category.addEventListener('focusin', function () { activate(index); });
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAll();
        var focused = root.querySelector('.jsmega__toplink:focus');
        if (focused) focused.blur();
      }
    });
  }

  function injectHeaderCorrections() {
    if (document.getElementById('js-v51-site-corrections')) return;

    var style = document.createElement('style');
    style.id = 'js-v51-site-corrections';
    style.textContent = [
      '/* Header: no cloud pattern inside Header 3. */',
      '@media (min-width:768px){',
      'body.pageindex header.headertype3 .tt-desktop-header{background-color:#28c5fe!important;background-image:none!important;}',
      'body.pageindex header.headertype3 .tt-desktop-header .tt-wrapper-light{background-color:transparent!important;background-image:none!important;}',
      '}',

      '/* Header promo cards: same black lower plate language as the quick-link tiles. */',
      '@media (min-width:1025px){',
      'body.pageindex header.headertype3 .js-header-roll-host{min-height:174px!important;overflow:visible!important;}',
      'body.pageindex header.headertype3 .js-header-art-rail{gap:18px!important;max-width:calc(100% - 405px)!important;overflow:visible!important;align-items:center!important;}',
      'body.pageindex header.headertype3 .js-header-art-rail .js-header-art-slot{position:relative!important;display:block!important;flex:0 0 200px!important;width:200px!important;height:170px!important;min-width:200px!important;min-height:170px!important;margin:0!important;border-radius:16px!important;overflow:hidden!important;transition:transform .2s ease,filter .2s ease!important;}',
      'body.pageindex header.headertype3 .js-header-art-rail .js-header-art-image{display:block!important;width:100%!important;height:128px!important;min-height:128px!important;border-radius:16px 16px 0 0!important;object-fit:cover!important;object-position:center top!important;}',
      'body.pageindex header.headertype3 .js-header-art-placeholder{display:flex!important;width:100%!important;height:128px!important;align-items:center!important;justify-content:center!important;font-size:48px!important;line-height:1!important;background:linear-gradient(145deg,#292c34 0%,#15171c 100%)!important;border:3px solid #edff1a!important;border-bottom:0!important;border-radius:16px 16px 0 0!important;}',
      'body.pageindex header.headertype3 .js-header-art-cta{position:absolute!important;left:0!important;right:0!important;bottom:0!important;z-index:6!important;display:flex!important;align-items:center!important;justify-content:center!important;height:42px!important;min-height:42px!important;padding:10px 7px!important;border:0!important;border-top:1px solid rgba(255,255,255,.11)!important;border-radius:0 0 15px 15px!important;background:linear-gradient(180deg,#202025 0%,#0c0c0f 100%)!important;color:#fff!important;font-size:10px!important;line-height:1!important;font-weight:900!important;letter-spacing:.025em!important;text-align:center!important;white-space:nowrap!important;box-shadow:none!important;pointer-events:none!important;}',
      'body.pageindex header.headertype3 .js-header-art-link:hover,body.pageindex header.headertype3 .js-header-art-link:focus-visible{transform:translateY(-3px)!important;}',
      'body.pageindex header.headertype3 .js-header-art-link:hover .js-header-art-image,body.pageindex header.headertype3 .js-header-art-link:focus-visible .js-header-art-image{transform:none!important;filter:brightness(1.06)!important;}',
      'body.pageindex header.headertype3 .js-header-art-link:hover .js-header-art-cta,body.pageindex header.headertype3 .js-header-art-link:focus-visible .js-header-art-cta{transform:none!important;background:linear-gradient(180deg,#2b2b31 0%,#111116 100%)!important;box-shadow:none!important;}',
      'header.headertype3 .tt-desktop-header .header-tel-info{display:flex!important;align-items:center!important;justify-content:center!important;}',
      'header.headertype3 .tt-desktop-header .header-tel-info>a{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;width:340px!important;max-width:340px!important;transform:none!important;text-align:center!important;}',
      'header.headertype3 .tt-desktop-header .header-tel-info>a>img{display:block!important;width:285px!important;max-width:285px!important;height:auto!important;margin:0 auto!important;}',
      'header.headertype3 .tt-desktop-header .header-tel-info>a>.js-bigger-bong-tagline{display:block!important;width:100%!important;margin:4px auto 12px!important;padding-bottom:2px!important;font-size:clamp(15px,1.1vw,19px)!important;line-height:1.15!important;text-align:center!important;white-space:nowrap!important;}',
      'header.headertype3 .js-bigger-bong-tagline::after{bottom:-6px!important;}',
      '}',
      '@media (min-width:1500px){body.pageindex header.headertype3 .js-header-art-slot:nth-child(n+1){display:block!important;}}',
      '@media (min-width:1320px) and (max-width:1499px){body.pageindex header.headertype3 .js-header-art-slot:nth-child(n+4){display:none!important;}}',
      '@media (min-width:1160px) and (max-width:1319px){body.pageindex header.headertype3 .js-header-art-slot:nth-child(n+3){display:none!important;}}',
      '@media (min-width:1025px) and (max-width:1159px){body.pageindex header.headertype3 .js-header-art-slot:nth-child(n+2){display:none!important;}}',
      '@media (max-width:1024px){header.headertype3 .js-header-art-rail{display:none!important;}header.headertype3 .js-bigger-bong-tagline{margin-top:4px!important;}}',

      '/* Video area: remove clouds and form a dark U/wave around the side mascots and the quick-link row, leaving the central video lane clear. */',
      '@media (min-width:768px){',
      'body.pageindex #tt-pageContent>[id$="index_section_video_banner_homepage"]{position:relative!important;isolation:isolate!important;overflow:visible!important;background-image:linear-gradient(90deg,#08090c 0 19%,#23b4ee 19% 81%,#08090c 81% 100%)!important;background-color:#08090c!important;}',
      'body.pageindex #tt-pageContent>[id$="index_section_video_banner_homepage"]::before{content:none!important;display:none!important;}',
      'body.pageindex #tt-pageContent>[id$="index_section_video_banner_homepage"]::after{content:""!important;display:block!important;position:absolute!important;z-index:0!important;left:-4%!important;width:108%!important;height:116px!important;bottom:-72px!important;background:#08090c!important;border-radius:50% 50% 0 0 / 72px 72px 0 0!important;pointer-events:none!important;}',
      'body.pageindex #tt-pageContent>[id$="index_section_video_banner_homepage"]>.container-indent{position:relative!important;z-index:1!important;background:transparent!important;}',
      'body.pageindex #tt-pageContent>[id$="index_section_iconbar_new"]{position:relative!important;z-index:2!important;background:#08090c!important;background-image:none!important;padding-top:14px!important;padding-bottom:16px!important;}',
      'body.pageindex #tt-pageContent>[id$="index_section_iconbar_new"] .container-indent,body.pageindex #tt-pageContent>[id$="index_section_iconbar_new"] .container{background:transparent!important;background-image:none!important;}',
      '}',
      '@media (max-width:767px){body.pageindex #tt-pageContent>[id$="index_section_video_banner_homepage"],body.pageindex #tt-pageContent>[id$="index_section_iconbar_new"]{background:#08090c!important;background-image:none!important;}}',

      '/* Homepage product rows: variants hidden everywhere; price becomes a desktop hover reveal and the whole card grows slightly. */',
      'body.pageindex [data-sectionname="index_sectionproducts"] .tt-product .tt-option-block{display:none!important;visibility:hidden!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;}',
      '@media (hover:hover) and (min-width:768px){',
      'body.pageindex [data-sectionname="index_sectionproducts"] .tt-product{position:relative!important;z-index:1!important;transition:transform .22s ease,box-shadow .22s ease!important;transform-origin:center center!important;}',
      'body.pageindex [data-sectionname="index_sectionproducts"] .tt-product .tt-price{max-height:0!important;opacity:0!important;visibility:hidden!important;overflow:hidden!important;margin-top:0!important;margin-bottom:0!important;transform:translateY(-6px)!important;transition:max-height .22s ease,opacity .18s ease,transform .22s ease,margin .22s ease!important;}',
      'body.pageindex [data-sectionname="index_sectionproducts"] .tt-product:hover,body.pageindex [data-sectionname="index_sectionproducts"] .tt-product:focus-within{z-index:25!important;transform:scale(1.035)!important;box-shadow:0 22px 44px -18px rgba(0,0,0,.75)!important;}',
      'body.pageindex [data-sectionname="index_sectionproducts"] .tt-product:hover .tt-price,body.pageindex [data-sectionname="index_sectionproducts"] .tt-product:focus-within .tt-price{max-height:46px!important;opacity:1!important;visibility:visible!important;margin-top:7px!important;margin-bottom:4px!important;transform:translateY(0)!important;}',
      '}',

      '/* Footer newsletter grey; the footer itself black. */',
      'footer.for-footer-blocks{background:#050506!important;}',
      'footer.for-footer-blocks .tt-footer-custom.jschar-footer-zone,footer .tt-footer-custom.jschar-footer-zone:has(.jschar-subscribe){background:#3d3e43!important;background-image:none!important;}',
      'footer .jschar-subscribe{--jschar-bg:#3d3e43!important;background:#3d3e43!important;}',
      'footer.for-footer-blocks .tt-footer-col.tt-color-scheme-03,footer.for-footer-blocks .tt-footer-col.tt-footer-type2,footer.for-footer-blocks .tt-footer-custom.tt-color-scheme-04{background:#050506!important;background-image:none!important;}',
      'footer.for-footer-blocks>.tt-footer-col,footer.for-footer-blocks>.tt-footer-custom.tt-color-scheme-04{border-color:rgba(255,255,255,.08)!important;}',
      'footer.for-footer-blocks .tt-box-copyright{color:#d7d7da!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildGeneratedHeaderTile(rail, config) {
    if (!rail || rail.querySelector('[data-js-header-generated="' + config.key + '"]')) return;

    var link = document.createElement('a');
    link.className = 'js-header-art-slot js-header-art-link js-header-art-generated';
    link.href = config.href;
    link.setAttribute('aria-label', config.label);
    link.setAttribute('data-js-header-generated', config.key);

    var sourceImage = null;
    if (config.sourceIndex !== undefined) {
      var giftImages = document.querySelectorAll('[id$="index_section_promocollections_giftsspotlight"] img');
      if (giftImages && giftImages[config.sourceIndex]) sourceImage = giftImages[config.sourceIndex];
    }

    if (sourceImage && sourceImage.src) {
      var img = document.createElement('img');
      img.className = 'js-header-art-image';
      img.src = sourceImage.currentSrc || sourceImage.src;
      img.alt = config.label;
      link.appendChild(img);
    } else {
      var placeholder = document.createElement('span');
      placeholder.className = 'js-header-art-placeholder';
      placeholder.textContent = config.emoji;
      link.appendChild(placeholder);
    }

    rail.appendChild(link);
  }

  function ensureFourHeaderTiles(header) {
    var rail = header.querySelector('.js-header-art-rail');
    if (!rail) return;

    buildGeneratedHeaderTile(rail, {
      key: 'bundles',
      href: '/collections/special-bundles-offers-by-justsmoke-me',
      label: 'Shop Bundles and Offers',
      emoji: '🎁',
      sourceIndex: 1
    });
    buildGeneratedHeaderTile(rail, {
      key: 'gifts',
      href: '/collections/gifts-for-her',
      label: 'Shop Gifts for Him and Her',
      emoji: '✨',
      sourceIndex: 2
    });
  }

  function initHeaderRefresh() {
    var header = document.querySelector('header.headertype3');
    if (!header) return;

    injectHeaderCorrections();
    ensureFourHeaderTiles(header);

    var taglines = header.querySelectorAll('.header-tel-info h1.title');
    Array.prototype.forEach.call(taglines, function (title) {
      title.textContent = '“You’re Gonna Need a Bigger Bong”';
      title.classList.add('js-bigger-bong-tagline');
    });

    var promos = header.querySelectorAll('.js-header-art-rail .js-header-art-link');
    var labels = ['MONTHLY BOX', 'SHOP £1 OR LESS', 'BUNDLES & OFFERS', 'GIFTS FOR HIM & HER'];
    Array.prototype.forEach.call(promos, function (link, index) {
      var cta = link.querySelector('.js-header-art-cta');
      if (!cta) {
        cta = document.createElement('span');
        cta.className = 'js-header-art-cta';
        cta.setAttribute('aria-hidden', 'true');
        link.appendChild(cta);
      }
      cta.textContent = (labels[index] || 'SHOP NOW') + '  →';
    });
  }

  function initAll() {
    document.querySelectorAll('.jsmega').forEach(initMegaMenu);
    initHeaderRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
